export const applicationconfig = {
  title1: 'ERM',
  title2: 'Survey',
  applicationName: null,
  showHelp:false,
  showSettings:true,
  showCreate:false,
  createOptions:[
    {
      title:"UI 1",
      link:"/create/survey/new",
      icon:"fa fa-server"
    }
  ]
};
